module.exports = __webpack_public_path__ + "static/media/image1.604cb842.jpg";